import { render, staticRenderFns } from "./Candidatos.vue?vue&type=template&id=04418f42&scoped=true&"
import script from "./Candidatos.vue?vue&type=script&lang=js&"
export * from "./Candidatos.vue?vue&type=script&lang=js&"
import style0 from "./Candidatos.vue?vue&type=style&index=0&id=04418f42&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04418f42",
  null
  
)

export default component.exports